module.exports = __webpack_public_path__ + "tg.801ef4aea9267a076f75.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tg.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tg.svg
// module chunks = styles